import React, { useState } from "react";
import ModalContainer from "../common/modal_container";
import commingSoonLogo from '../../_asset/casino/commingsoon.jpg'
import commingSoonVideo from '../../_asset/media/comming_soon_olympic.mp4'
import { Player } from "@lottiefiles/react-lottie-player";
import loading from "../../_asset/lottie/ready_casino.json"

export function CommingSoonPop() {
    const [popShow, setPopShow] = useState<boolean>(false)

    return (
        <>
            <p className={"--pointer"} onClick={e => setPopShow(true)}></p>
            <CommingSoonModal popShow={popShow} setPopShow={setPopShow} />
        </>
    );
}


export function CommingSoonModal({ popShow, setPopShow }: { popShow: boolean; setPopShow: Function }) {
    return (
        <ModalContainer show={popShow}
            setShow={setPopShow}
            closeBtn={true}
            className={'comming-soon'}
        >
            {/*카지노*/}
            {/*<img src={commingSoonLogo} alt=""/>*/}
            {/*<video src={commingSoonVideo} autoPlay={true} muted loop/>*/}
            <div className={'comming-soon-message'}>
                <Player src={loading}
                    loop
                    autoplay
                    style={{ width: "22rem", height: "22rem" }}></Player>
                <p>점검중 입니다...</p>
            </div>
        </ModalContainer>
    )
}